export default __webpack_public_path__ + "img/6bde413fb3cb83b110007bb45d824178.png";